import Cookies from 'js-cookie'

const TokenKey = 'KKKOR-Token'
const TokenPrefixPattern = /^Bearer\s+/i

// 兼容历史上已写成 "Bearer xxx" 的 token，统一按原始 token 持久化与读取
export function normalizeToken(token) {
    if (typeof token !== 'string') {
        return ''
    }
    let normalizedToken = token.trim()
    while (TokenPrefixPattern.test(normalizedToken)) {
        normalizedToken = normalizedToken.replace(TokenPrefixPattern, '').trim()
    }
    return normalizedToken
}

export function getToken() {
    return normalizeToken(Cookies.get(TokenKey))
}

export function getAuthorizationToken() {
    const token = getToken()
    return token ? `Bearer ${token}` : ''
}

export function setToken(token) {
    const normalizedToken = normalizeToken(token)
    return Cookies.set(TokenKey, normalizedToken, { path: '/' })
}

export function removeToken() {
    return Cookies.remove(TokenKey, { path: '/' })
}
